import React from 'react';
import { Table, Column } from 'fixed-data-table';
import { find, filter, update, orderBy } from 'lodash';

import { SortHeaderCell, DataListWrapper, TextCell, TrueOrFalseCell } from '../../../commonComponents/DataTable/DataTablePs';
import treeViewGenerator from '../../../commonComponents/treeViewGenerator';
import { optsGeneratorCommon } from '../../../commonComponents/DropDownMenu';
import ToggleVisibleBtn from '../../../commonComponents/ToggleVisibleBtn';

import UserPermissionModalCt from './UserPermissionModalCt';
import adminGroupCategories from './adminGroupCategories';
import { PermissionEditCell, UserImgCell, ColorCell } from './CustCells';

import getAdminItemStateName from './getAdminItemStateName';

import custJqAjax from '../../../commonJS/custJqAjax';
import parentStateHandler from '../../../commonJS/parentStateHandler';
// import searchContent from '../../../commonJS/searchContent';


export default class NewAdminCt extends React.PureComponent {
	constructor(props) {
		super(props);

		const { languageData, languageCode } = window.myConsts;

		this.handlers = {
			onRowClick: (e, rowIndex, sortedData, keepRoute, cutTail) => {
				const selectedItem = sortedData.getObjectAt(rowIndex);

				let route = this.props.location.pathname;

				if (cutTail) {
					route = route.slice(0, route.lastIndexOf('/') + 1);
				} else {
					route += '/';
				}

				let idKeyName, nameKeyName;

				switch (this.props.activeAdminItem) {
					case 'user-account':
						idKeyName = 'user_account';
						nameKeyName = 'user_name';
						break;
					case 'user-role':
						idKeyName = 'sub_role';
						nameKeyName = 'role_name';
						break;
					case 'system-parameter-setting':
						idKeyName = 'id';
						nameKeyName = 'item';
						break;
					case 'company-introduction':
						idKeyName = '';
						nameKeyName = 'company_name';
						break;
					case 'repair-area':
						idKeyName = 'area_type_id';
						nameKeyName = 'area_type_name';
						break;
					case 'repair-status':
						idKeyName = 'status_id';
						nameKeyName = 'status_name';
						break;
					case 'repair-form-type':
						idKeyName = 'type_id';
						nameKeyName = 'type_name';
						break;
					case 'repair-warranty-type':
						idKeyName = 'warranty_type_id';
						nameKeyName = 'warranty_type_name';
						break;
					case 'repair-product-from':
						idKeyName = 'from_id';
						nameKeyName = 'from_name';
						break;
					case 'repair-service-type':
						idKeyName = 'service_type_id';
						nameKeyName = 'service_type_name';
						break;
					case 'repair-owner-judgement':
						idKeyName = 'judge_id';
						nameKeyName = 'judge_name';
						break;
					case 'repair-currency':
						idKeyName = 'currency_id';
						nameKeyName = 'currency_name';
						break;
					case 'repair-service-satisfaction':
						idKeyName = 'satisfaction_id';
						nameKeyName = 'satisfaction_name';
						break;
					case 'repair-issue-type':
						idKeyName = 'issue_type_id';
						nameKeyName = 'issue_type_name';
						break;
					default:
						idKeyName = 'id';
						nameKeyName = 'name';
				};

				// single-item 特定單一項目，如公司簡介
				const id = selectedItem[idKeyName] || 'single-item',
					name = selectedItem[nameKeyName];

				if (!keepRoute) this.props.routeHandler(route + id);

				this.setState({
					selectedRowIndex: rowIndex,
					selectedItemId: id,
					selectedItemName: name
				});
			},
			onSortChange: (columnKey, sortDir, SortTypes, indexes, data) => {

				if (this.props.activeAdminItem === 'default') return;

				// 前3個參數預設由子元件傳入，後兩個視使用當下情況自行傳入
				let sortIndexes = indexes || this.props.adminSortedData._indexMap;
				const orinData = data || this.props.adminSortedData._data;

				sortIndexes.sort((indexA, indexB) => {

					const valueA = orinData[indexA][columnKey];
					const valueB = orinData[indexB][columnKey];
					let sortVal = 0;
					if (valueA > valueB) {
						sortVal = 1;
					}
					if (valueA < valueB) {
						sortVal = -1;
					}
					if (sortVal !== 0 && sortDir === SortTypes.ASC) {
						sortVal *= -1;
					}

					return sortVal;
				});

				const stateName = getAdminItemStateName(this.props.activeAdminItem);

				this.props.parentStateHandler({
					states: [stateName.dataWrapperStateName, stateName.colSortDirsStateName],
					newValues: [
						new DataListWrapper(sortIndexes, orinData),
						{
							[columnKey]: sortDir
						}
					]
				});
			},
			onHideRightSide: () => {
				this.setState({ hideRightSide: !this.state.hideRightSide });
			}
		};

		this.variables = {
			tableFields: {
				'default': [
					{
						columnKey: '',
						title: languageData['636'][languageCode],
						flexGrow: 1,
						width: 100,
						onClick: '',
						CustCell: ''
					}
				],
				'user-account': [
					{
						columnKey: 'permissionSetting',
						title: languageData['642'][languageCode],
						flexGrow: 0,
						width: 100,
						onClick: (e, rowIndex, sortedData) => {
							e.stopPropagation();
							const selectedItem = sortedData.getObjectAt(rowIndex),
								id = selectedItem.user_account,
								name = selectedItem.user_name; // 多國

							this.setState({
								showPermissionModal: true,
								selectedRowIndex: rowIndex,
								selectedItemId: id,
								selectedItemName: name
							});
						},
						CustCell: PermissionEditCell
					},
					{
						columnKey: 'enabled',
						title: languageData['142'][languageCode],
						flexGrow: 0,
						width: 110,
						CustCell: TrueOrFalseCell
					},
					{
						columnKey: 'img_path',
						title: languageData['89'][languageCode],
						flexGrow: 0,
						width: 100,
						CustCell: UserImgCell
					},
					{
						columnKey: 'emp_id',
						title: languageData['141'][languageCode],
						flexGrow: 1,
						width: 110,
					},
					{
						columnKey: 'user_name',
						title: languageData['37'][languageCode],
						flexGrow: 1,
						width: 100,
					},
					{
						columnKey: 'email',
						title: languageData['61'][languageCode],
						flexGrow: 3,
						width: 150,
					},
					{
						columnKey: 'user_account',
						title: languageData['151'][languageCode],
						flexGrow: 3,
						width: 150,
					},
					{
						columnKey: 'group_name',
						title: languageData['152'][languageCode],
						flexGrow: 1,
						width: 100,
					},
					{
						columnKey: 'role_name',
						title: languageData['154'][languageCode],
						flexGrow: 1,
						width: 100,
					},
					{
						columnKey: 'is_fix_user',
						title: languageData['644'][languageCode],
						flexGrow: 0,
						width: 110,
						CustCell: TrueOrFalseCell
					},
					{
						columnKey: 'is_admin',
						title: '系統管理員',
						flexGrow: 0,
						width: 100,
						CustCell: TrueOrFalseCell
					}
				],
				'user-role': [
					{
						columnKey: 'parentRoleName',
						title: languageData['640'][languageCode],
						flexGrow: 1,
						width: 100
					},
					{
						columnKey: 'role_name',
						title: '角色名稱',
						flexGrow: 1,
						width: 100
					},
					{
						columnKey: 'departmentName',
						title: '群組名稱',
						flexGrow: 1,
						width: 100
					}
				],
				'user-group': [
					{
						columnKey: 'name',
						title: languageData['11'][languageCode],
						flexGrow: 1,
						width: 100
					},
					{
						columnKey: 'color_code',
						title: '群組顏色',
						flexGrow: 1,
						width: 100,
						CustCell: ColorCell
					}
				],
				'supervisor-evaluation': [
					{
						columnKey: 'name',
						title: '評核等級',
						flexGrow: 1,
						width: 100
					},
					{
						columnKey: 'remark',
						title: '評語',
						flexGrow: 1,
						width: 100
					}
				],
				'repair-area': [
					{
						columnKey: 'area_type_name',
						title: '地區',
						flexGrow: 1,
						width: 100
					}
				],
				'repair-status': [
					{
						columnKey: 'status_name',
						title: '表單狀態',
						flexGrow: 1,
						width: 100
					},
					{
						columnKey: 'color_code',
						title: '狀態顏色',
						flexGrow: 1,
						width: 100,
						CustCell: ColorCell
					}
				],
				'repair-form-type': [
					{
						columnKey: 'type_name',
						title: '表單類型',
						flexGrow: 1,
						width: 100
					}
				],
				'repair-warranty-type': [
					{
						columnKey: 'warranty_type_name',
						title: '保固類型',
						flexGrow: 1,
						width: 100
					}
				],
				'repair-product-from': [
					{
						columnKey: 'from_name',
						title: '產品來源',
						flexGrow: 1,
						width: 100
					}
				],
				'repair-service-type': [
					{
						columnKey: 'service_type_name',
						title: '服務類別',
						flexGrow: 1,
						width: 100
					}
				],
				'repair-owner-judgement': [
					{
						columnKey: 'judge_name',
						title: '責任歸屬',
						flexGrow: 1,
						width: 100
					}
				],
				'repair-currency': [
					{
						columnKey: 'currency_name',
						title: '幣別',
						flexGrow: 1,
						width: 100
					}
				],
				'repair-service-satisfaction': [
					{
						columnKey: 'satisfaction_name',
						title: '服務結果',
						flexGrow: 1,
						width: 100
					}
				],
				'repair-issue-type': [
					{
						columnKey: 'issue_type_name',
						title: '問題分類',
						flexGrow: 1,
						width: 100
					}
				],
				'system-parameter-setting': [
					{
						columnKey: 'item',
						title: '參數名稱',
						flexGrow: 1,
						width: 100
					},
					{
						columnKey: 'value',
						title: '設定值',
						flexGrow: 1,
						width: 100
					},
					{
						columnKey: 'remark',
						title: '備註',
						flexGrow: 1,
						width: 100
					}
				],
				'company-introduction': [
					{
						columnKey: 'company_name',
						title: '公司名稱',
						flexGrow: 1,
						width: 100
					},
					{
						columnKey: 'title',
						title: '簡介抬頭',
						flexGrow: 1,
						width: 100
					},
					{
						columnKey: 'content',
						title: '簡介內容',
						flexGrow: 1,
						width: 100
					}
				],
				'company-zone': [
					{
						columnKey: 'name',
						title: '區域',
						flexGrow: 1,
						width: 100
					}
				],
				'company-industry': [
					{
						columnKey: 'name',
						title: '行業別',
						flexGrow: 1,
						width: 100
					}
				],
				'company-trade': [
					{
						columnKey: 'name',
						title: '產業',
						flexGrow: 1,
						width: 100
					}
				],
				'work-nature': [
					{
						columnKey: 'name',
						title: '工作性質',
						flexGrow: 1,
						width: 100
					}
				],
				'work-progress': [
					{
						columnKey: 'name',
						title: '工作進度',
						flexGrow: 1,
						width: 100
					}
				],
				'project-progress': [
					{
						columnKey: 'name',
						title: '專案狀態',
						flexGrow: 1,
						width: 100
					}
				],
				'media-cloud-file-attribute': [
					{
						columnKey: 'name',
						title: '檔案屬性',
						flexGrow: 1,
						width: 100
					}
				],
				'media-cloud-file-attribute-value': [
					{
						columnKey: 'attributeName',
						title: '檔案屬性',
						flexGrow: 1,
						width: 100
					},
					{
						columnKey: 'name',
						title: '檔案屬性值',
						flexGrow: 1,
						width: 100
					}
				],
				'news-type': [
					{
						columnKey: 'name',
						title: '新聞分類',
						flexGrow: 1,
						width: 100
					}
				]
			}
		};

		this.funcs = {
			modalPropsByAdminItem: (activeAdminItem) => {
				switch (activeAdminItem) {
					case 'user-account':
					case 'user-role':
						const userRoleSortedData =
							(
								activeAdminItem === 'user-account'
									? this.props.userRoleSortedData._data
									: this.props.adminSortedData._data
							),
							userGroupSortedData = this.props.userGroupSortedData._data;

						let optsUserRole, optsUserGroup;

						if (userRoleSortedData) {
							optsUserRole = optsGeneratorCommon(
								userRoleSortedData,
								['value', 'label'],
								['sub_role', 'role_name']
							);
						} else {
							optsUserRole = [];
						}

						if (userGroupSortedData) {
							optsUserGroup = optsGeneratorCommon(
								userGroupSortedData,
								['value', 'label'],
								['id', 'name']
							);
						} else {
							optsUserGroup = [];
						}


						return {
							optsUserGroup,
							optsUserRole
						};

					case 'repair-area':
					case 'repair-status':
					case 'repair-form-type':
					case 'repair-warranty-type':
					case 'repair-product-from':
					case 'repair-service-type':
					case 'repair-owner-judgement':
					case 'repair-currency':
					case 'repair-service-satisfaction':
					case 'repair-issue-type':
					case 'news-type':
						return {
							apiAdaptedData: this.props.apiAdaptedData
						};
					case 'work-nature':
					case 'work-progress':
					case 'project-progress':
						let obj = {};

						switch (activeAdminItem) {
							case 'work-nature':
								obj.optsWorkNature = this.props.optsWorkNature;
								break;
							case 'work-progress':
								obj.optsProgressStatus = this.props.optsProgressStatus;
								break;
							case 'project-progress':
								obj.optsProjectProgress = this.props.optsProjectProgress;
								break;
							default:

						}

						return {
							saleSkyStateHandler: this.props.stateHandler,
							...obj
						};
					case 'media-cloud-file-attribute-value':
						const mediaCloudFileAttributeSortedData = this.props.mediaCloudFileAttributeSortedData._data;

						let optsFileProperty;

						if (mediaCloudFileAttributeSortedData) {
							optsFileProperty = optsGeneratorCommon(
								mediaCloudFileAttributeSortedData,
								['value', 'label'],
								['id', 'name']
							);
						} else {
							optsFileProperty = [];
						}

						return {
							optsFileProperty
						};

					default:
						return {};
				}
			},
			loadTableData: (api, dataWrapperStateName, apiAdaptedDataStateName) => {
				const jqAjaxIdGenerator = props.propsPackageFromSkyFamily.jqAjaxIdGenerator;

				// 由於在componentWillReceiveProps判斷是否需下載資料
				// 在下載完畢之前._data仍會是undefined，但cwrp可能已觸發不只1次
				// 可能造成重複抓取，故一開始下載就移除shouldFetchData key預防
				// 雖可新增一個onLoading state控制，但給設定物件不需額外state
				this.props.parentStateHandler({
					states: dataWrapperStateName,
					newValues: {}
				});

				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: jqAjaxIdGenerator.getId(),
					url: `/api/${api}`,
					success: res => {
						const extraStates = [],
							extraNewValues = [];

						let sortedData;
						if (res.status === '0') {
							// 特別處理 for api
							let data = (res.result[0] ? res.result : [res.result]),
								defaultSortIndexes = [];

							// api 傳回格式不一致處理... ===
							switch (this.props.activeAdminItem) {
								case 'user-account':
									// 轉成數字後排序再轉成文字								
									// 排序條件：啟用(是)、使用者名稱(空白、0-9、A-Z、a-z)
									if (data.length && data[0].user_id) {
										for (let dataIdx = 0; dataIdx < data.length; dataIdx++) {
											update(data, `[${dataIdx}]enabled`, function (n) {
												if (n === 'true' || n === true) return '1';
												else if (n === 'false' || n === false) return '0';
												else return (n * 1).toString();
											});
										}

										data = orderBy(data, ['enabled', 'user_name'], ['desc', 'asc']);
									}
									break;

								case 'repair-area':
								case 'repair-status':
								case 'repair-form-type':
								case 'repair-warranty-type':
								case 'repair-product-from':
								case 'repair-service-type':
								case 'repair-owner-judgement':
								case 'repair-currency':
								case 'repair-service-satisfaction':
								case 'repair-issue-type':
								case 'news-type':
									// 儲存完整資料
									extraStates.push(apiAdaptedDataStateName);
									extraNewValues.push(data);
									// 過濾 table 資料
									data = filter(data, { lang_code: 'zh-tw' });
									break;

								default:
							};

							// ===

							for (let i = 0, len = data.length; i < len; i++) {
								defaultSortIndexes.push(i);
							}

							sortedData = new DataListWrapper(defaultSortIndexes, data);

						} else {
							sortedData = new DataListWrapper([], []);
						}

						this.props.parentStateHandler({
							states: [dataWrapperStateName, ...extraStates],
							newValues: [sortedData, ...extraNewValues]
						});

					}
				});
			}
		};

		this.treeViewFuncs = {
			onTreeViewNodeClick: (parentObj, selectedTracks, selectedTrackNames, selectedTrackIds) => {
				const lastPos = selectedTracks.length - 1;
				// ind = selectedTracks[lastPos];

				let collapses = this.state.collapsesState,
					collapseKey = selectedTrackIds[lastPos];

				collapses[collapseKey] = !collapses[collapseKey];

				const { productTreeView, collapsesState } = treeViewGenerator(adminGroupCategories({ isSuperAdmin: this.props.propsPackageFromSkyFamily.isSuperAdmin }), collapses, this.treeViewFuncs.onTreeViewNodeClick, selectedTrackIds[lastPos], '', '', 'name_tw');

				// this.treeViewFuncs.updateProductTable(tarObj);
				// 離開即重置的狀態由this管理
				this.setState({ doSearchUpdate: 1, treeView: productTreeView, collapsesState, selectedTracks, selectedTrackIds });

				// routing
				let route = '/salesky/new-admin';

				for (let i = 1, len = selectedTrackIds.length; i < len; i++) {
					route += '/' + selectedTrackIds[i];
				}

				if (route !== this.props.router.location.pathname) {
					this.props.routeHandler(route);
				}

				this.props.onSearchTextClear();

			},
			closeModal: (stateName) => {
				this.setState({ [stateName]: false });
			}
		}

		this.parentStateHandler = ({ states, newValues }) => {
			parentStateHandler({ states, newValues, parentThis: this });
		};

		this.ajaxsWip = [];
		// this.timer = {};

		this.state = {
			selectedRowIndex: '',
			selectedItemId: '',
			selectedItemName: '',
			doSearchUpdate: 0,
			// tree view
			selectedTrackIds: [],
			treeView: [],
			collapsesState: { '0': false }, // 以categories id做為key，管控各tacks摺疊狀態
			selectedTracks: [0], // 隨階層push array，值為sort
			// user account ===
			hideRightSide: false,
			// permission
			showPermissionModal: false
			// ===
		};
	}

	componentWillReceiveProps(nextProps) {
		const activeAdminItem = nextProps.activeAdminItem;

		switch (activeAdminItem) {
			case 'user-account':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ManageAccount_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}

				if (nextProps.userRoleSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_Role_Get.php',
						'userRoleSortedData'
					);
				}

				if (nextProps.userGroupSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_UserGroup_Get.php',
						'userGroupSortedData'
					);
				}
				break;
			case 'user-role':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_Role_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}

				if (nextProps.userGroupSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_UserGroup_Get.php',
						'userGroupSortedData'
					);
				}
				break;
			case 'user-group':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_UserGroup_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}
				break;
			case 'supervisor-evaluation':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_Supervisor_Review_Type_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}
				break;
			case 'company-zone':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_Zone_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}
				break;
			case 'company-industry':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_Industry_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}
				break;
			case 'company-trade':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_Trade_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}
				break;
			case 'work-nature':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_WorkNature_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}
				break;
			case 'work-progress':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ProgressStatus_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}
				break;
			case 'project-progress':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ProjectProgress_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}

				break;
			case 'media-cloud-file-attribute':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_FileProperty_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}
				break;
			case 'media-cloud-file-attribute-value':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_FilePropertyValue_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}

				if (nextProps.mediaCloudFileAttributeSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_FileProperty_Get.php',
						'mediaCloudFileAttributeSortedData'
					);
				}
				break;
			case 'news-type':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_SaleSky_News_Type_Lang_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName,
						getAdminItemStateName(activeAdminItem).apiAdaptedDataStateName
					);
				}
				break;
			case 'repair-area':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ServiceSky_RepairSky_Area_Type_Lang_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName,
						getAdminItemStateName(activeAdminItem).apiAdaptedDataStateName
					);
				}
				break;
			case 'repair-status':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ServiceSky_RepairSky_Status_Lang_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName,
						getAdminItemStateName(activeAdminItem).apiAdaptedDataStateName
					);
				}
				break;
			case 'repair-form-type':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ServiceSky_RepairSky_Type_Lang_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName,
						getAdminItemStateName(activeAdminItem).apiAdaptedDataStateName
					);
				}
				break;
			case 'repair-warranty-type':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ServiceSky_RepairSky_Warranty_Type_Lang_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName,
						getAdminItemStateName(activeAdminItem).apiAdaptedDataStateName
					);
				}
				break;
			case 'repair-product-from':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ServiceSky_RepairSky_From_Type_Lang_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName,
						getAdminItemStateName(activeAdminItem).apiAdaptedDataStateName
					);
				}
				break;
			case 'repair-service-type':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ServiceSky_RepairSky_Service_Type_Lang_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName,
						getAdminItemStateName(activeAdminItem).apiAdaptedDataStateName
					);
				}
				break;
			case 'repair-owner-judgement':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ServiceSky_RepairSky_Judge_Type_Lang_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName,
						getAdminItemStateName(activeAdminItem).apiAdaptedDataStateName
					);
				}
				break;
			case 'repair-currency':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ServiceSky_RepairSky_Currency_Lang_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName,
						getAdminItemStateName(activeAdminItem).apiAdaptedDataStateName
					);
				}
				break;
			case 'repair-service-satisfaction':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ServiceSky_RepairSky_Satisfaction_Type_Lang_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName,
						getAdminItemStateName(activeAdminItem).apiAdaptedDataStateName
					);
				}
				break;
			case 'repair-issue-type':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_ServiceSky_RepairSky_Issue_Type_Lang_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName,
						getAdminItemStateName(activeAdminItem).apiAdaptedDataStateName
					);
				}
				break;
			case 'system-parameter-setting':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_System_Environment_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}
				break;
			case 'company-introduction':
				if (nextProps.adminSortedData.shouldFetchData) {
					this.funcs.loadTableData(
						'W_UserCompanyInfo_Get.php',
						getAdminItemStateName(activeAdminItem).dataWrapperStateName
					);
				}
				break;

			default:
		};
	}

	componentDidMount() {
		// 重新整理情況下路由展開treeView
		const routes = this.props.location.pathname.split('/');
		let collapses = { '0': false },
			activeCategory = '0';

		if (routes.length > 3) {
			for (let i = 3, len = routes.length; i < len; i++) {
				collapses[routes[i]] = false;
			}

			activeCategory = routes[routes.length - 1];
		}

		const { productTreeView, collapsesState } = treeViewGenerator(adminGroupCategories({ isSuperAdmin: this.props.propsPackageFromSkyFamily.isSuperAdmin }), collapses, this.treeViewFuncs.onTreeViewNodeClick, activeCategory, '', '', 'name_tw');

		this.setState({
			treeView: productTreeView,
			collapsesState
		});

	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.doSearchUpdate) {
			this.setState({ doSearchUpdate: 0 });
			this.props.updateSearchResults();
		}
	}

	componentWillUnmount() {
		this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
	}

	render() {
		const state = this.state,
			props = this.props;

		let adminSortedData = props.adminSortedData,
			adminColSortDirs = props.adminColSortDirs;

		// search process
		let sortFunc = this.handlers.onSortChange;
		if (props.searchResults._data) {
			adminSortedData = props.searchResults;
			sortFunc = '';
		}

		// modalPropsByAdminItem
		const modal = (
			props.children ? React.cloneElement(props.children, {
				closeModal: props.closeModal,
				propsPackageFromSkyFamily: props.propsPackageFromSkyFamily,
				// modal更新的始終是篩選前的資料
				sortedData: props.adminSortedData,
				// for pagerUd
				filteredSortedData: adminSortedData,
				stateHandler: props.parentStateHandler,
				parentStateHandler: this.parentStateHandler,
				selectedRowIndex: state.selectedRowIndex,
				selectedItemId: state.selectedItemId,
				onRowClick: this.handlers.onRowClick,
				activeAdminItem: props.activeAdminItem,
				...this.funcs.modalPropsByAdminItem(props.activeAdminItem)
			}) : ''
		),
			tableWidth = ((props.isBigSideBar ? 0 : 186) + props.tableWidth) / (state.hideRightSide ? 1 : 2),
			tableHeight = (props.tableHeight || 477);

		// user-role table view 資料轉換 ===
		if (props.activeAdminItem === 'user-account' && adminSortedData._data) {
			// 有修改需求則用slice建新arr，無修改需求則免
			const
				dataArr = adminSortedData._data.slice(),
				groupDataArr = props.userGroupSortedData._data || [],
				roleDataArr = props.userRoleSortedData._data || [];

			for (let i = dataArr.length - 1; i >= 0; i--) {
				let groupObj = find(groupDataArr, { id: dataArr[i].user_group }),
					roleObj = find(roleDataArr, { sub_role: dataArr[i].role_id });

				dataArr[i].group_name = groupObj ? groupObj.name : '';
				dataArr[i].role_name = roleObj ? roleObj.role_name : '';

			}
			adminSortedData = new DataListWrapper(adminSortedData._indexMap, dataArr);
			// media-cloud-file-attribute-value table view 資料轉換 ===
		} else if (props.activeAdminItem === 'user-role' && adminSortedData._data) {
			// 有修改需求則用slice建新arr，無修改需求則免
			const dataArr = adminSortedData._data.slice(),
				groupDataArr = props.userGroupSortedData._data || [];

			for (let i = dataArr.length - 1; i >= 0; i--) {
				let parentRoleObj = find(dataArr, { sub_role: dataArr[i].main_role }),
					departmentObj = find(groupDataArr, { id: dataArr[i].department_id });

				dataArr[i].parentRoleName = parentRoleObj ? parentRoleObj.role_name : '';
				dataArr[i].departmentName = departmentObj ? departmentObj.name : '';

			}
			adminSortedData = new DataListWrapper(adminSortedData._indexMap, dataArr);
			// media-cloud-file-attribute-value table view 資料轉換 ===
		} else if (props.activeAdminItem === 'media-cloud-file-attribute-value' && adminSortedData._data) {
			const dataArr = adminSortedData._data.slice(),
				attributeDataArr = props.mediaCloudFileAttributeSortedData._data || [];

			for (let i = dataArr.length - 1; i >= 0; i--) {
				let attributeObj = find(attributeDataArr, { id: dataArr[i].fileproperty_id });

				dataArr[i].attributeName = attributeObj ? attributeObj.name : '';

			}
			adminSortedData = new DataListWrapper(adminSortedData._indexMap, dataArr);
		}
		// ===

		return (
			<div id='div-product-content-container' style={{ position: 'relative' }}>

				<ToggleVisibleBtn
					style={{ position: 'absolute', margin: 0, top: -50.5, right: 0 }}
					onClick={this.handlers.onHideRightSide} />

				<div id='div-product-content-left-side'
					style={{ width: state.hideRightSide ? '100%' : '' }}>

					{
						adminSortedData._data ?
							<Table
								onRowClick={(e, rowIndex) => { this.handlers.onRowClick(e, rowIndex, adminSortedData); }}
								rowHeight={props.activeAdminItem === 'user-account' ? 100 : 50}
								headerHeight={50}
								rowsCount={adminSortedData.getSize()}
								width={tableWidth}
								height={tableHeight}>

								{
									this.variables.tableFields[props.activeAdminItem].map((item, ind) => {
										return (
											<Column
												key={ind}
												columnKey={item.columnKey}
												header={
													<SortHeaderCell
														onSortChange={sortFunc}
														sortDir={adminColSortDirs[item.columnKey]}>
														{item.title}
													</SortHeaderCell>
												}
												cell={
													item.CustCell ?
														(
															item.onClick ?
																<item.CustCell onClick={item.onClick} sortedData={adminSortedData} />
																:
																<item.CustCell sortedData={adminSortedData} />
														)
														:
														<TextCell sortedData={adminSortedData} />
												}
												flexGrow={item.flexGrow}
												width={item.width}
											/>
										);
									})
								}

							</Table>
							: 'Data loading...'
					}


				</div>

				<div
					id='div-product-content-right-side'
					style={{
						display: state.hideRightSide ? 'none' : '',
						height: tableHeight,
						borderRight: '1px solid rgb(211, 211, 211)',
						borderBottom: '1px solid rgb(211, 211, 211)',
						backgroundColor: 'white'
					}}>

					<div style={{
						height: 51,
						// width: '50%',
						lineHeight: '51px',
						fontSize: 16,
						color: 'white',
						backgroundColor: 'rgb(5, 110, 185)',
						borderTop: '1px solid rgb(211, 211, 211)',
						borderBottom: '1px solid rgb(211, 211, 211)',
						paddingLeft: 8,
						position: 'relative'
					}}>
						功能群組
					</div>
					<div id='div-tree-view-container' style={{ height: tableHeight - 52 }}>
						{this.state.treeView}
					</div>

				</div>

				{modal}

				{
					this.state.showPermissionModal ?
						<UserPermissionModalCt
							closeModal={() => {
								this.treeViewFuncs.closeModal('showPermissionModal');
							}}
							propsPackageFromSkyFamily={props.propsPackageFromSkyFamily}
							sortedData={props.adminSortedData}
							filteredSortedData={adminSortedData}
							stateHandler={props.parentStateHandler}
							parentStateHandler={this.parentStateHandler}
							selectedRowIndex={state.selectedRowIndex}
							selectedItemId={state.selectedItemId}
							onRowClick={this.handlers.onRowClick}
							languageData={props.languageData} />
						: ''
				}
			</div>
		);
	}

}


// WEBPACK FOOTER //
// ./src/salesky/routes/newAdmin/NewAdminCt.jsx